/* eslint-disable */

import { SHA3 } from 'sha3'

export function getSha3Hash(s) {
  const hash = new SHA3(512)
  hash.update(s)
  return hash.digest('hex')
}

export function consoleLogHeader(s) {
  console.log(`\n\n===== ${s} ====================\n`)
}

export function consoleLogHeaderItem(s) {
  console.log(`-- ${s}\n`)
}

export function titleCase(string) {
  const sentence = string
    .toLowerCase()

    .split(' ')
  for (let i = 0; i < sentence.length; i++) {
    sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1)
  }
  return sentence.join().replace('_', ' ')
}

export function formatDate(d) {
  const ret = new Date(d)
  if (ret < new Date('1/1/2000')) {
    return '--'
  } else {
    return ret.toLocaleDateString()
  }
}

export function getRandomUuidv4() {
  consoleLogHeader('getRandomUuidv4 entered...')
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
  )
}

export function escapeHTML(html_str) {
  'use strict';

  return html_str.replace(/[&<>"]/g, function (tag) {
    var chars_to_replace = {
            '&': '&',
            '<': '<',
            '>': '>',
            '"': '"'
        };

    return chars_to_replace[tag] || tag;
  });
}